import { render, staticRenderFns } from "./goodCategory.vue?vue&type=template&id=70632f13&scoped=true"
import script from "./goodCategory.vue?vue&type=script&lang=js"
export * from "./goodCategory.vue?vue&type=script&lang=js"
import style0 from "./goodCategory.vue?vue&type=style&index=0&id=70632f13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70632f13",
  null
  
)

export default component.exports